import dayjs from "dayjs"

export const getMaxEndDate = (startDateValue: dayjs.Dayjs | null | undefined, number: number, unit: dayjs.ManipulateType): dayjs.Dayjs => {
  if (!startDateValue) {
    return dayjs()
  }

  const maxDate = startDateValue.add(number, unit)

  if (maxDate.isBefore(dayjs())) {
    return maxDate
  }

  return dayjs()
}

export const getMaxStartDate = (endDateValue: dayjs.Dayjs | null | undefined): dayjs.Dayjs => {
  if (!endDateValue) {
    return dayjs()
  }

  const maxDate = endDateValue

  if (maxDate.isBefore(dayjs())) {
    return maxDate
  }

  return dayjs()
}

export const renderDuration = (duration: string, autoConvertToHour = true) => {
  if (!duration) {
    return ''
  }

  const durationArray = duration.split(':')

  if (durationArray.length === 2) {
    if(parseInt(durationArray[0]) >= 60 && autoConvertToHour) {
      //Minute to Hour, rest minute, and seconds
      const hour = Math.floor(parseInt(durationArray[0]) / 60)
      const minute = parseInt(durationArray[0]) % 60
      return `${hour}h ${minute}min ${durationArray[1]}s`
    }
      
    //Minute and Seconds
    return `${durationArray[0]}min ${durationArray[1]}s`
  }

  if (durationArray.length === 3) {
    //Hours, Minute and Seconds
    return `${durationArray[0]}h ${durationArray[1]}min ${durationArray[2]}s`
  }

  //seconds
  return `${durationArray[0]}s`
}

export const degreesToRadians = (degrees: number): number => {
  // Multiply degrees by pi divided by 180 to convert to radians.
  return degrees * (Math.PI / 180);
}

export type MapLevelLabelProps = {
  positivePrefix?: string;
  negativePrefix?: string;
  groundLevelLabel?: string;
};

const defaultMapLevelLabelOptions: MapLevelLabelProps = {
  positivePrefix: "L",
  negativePrefix: "B",
  groundLevelLabel: "GL"
}
export const getMapLevelLabel = (level: number, options?: MapLevelLabelProps): string => {
  const optionValue: MapLevelLabelProps = { ...defaultMapLevelLabelOptions, ...options };
  if (level === null || level === undefined || level === 0) {
    return optionValue.groundLevelLabel || ""
  }
  if (level < 0) {
    return (optionValue.negativePrefix || "") + Math.abs(level);
  }
  return (optionValue.positivePrefix || "") + level;
}